import React, { useMemo } from 'react';
import { useTemplateOrCalculation } from '../../../../../../hooks/useTemplateOrCalculation';
import { useGetPickingInsightsQuery } from '../../../apiCalculationPickingResults';
import { StorePickingInsightsResponse } from '@ydistri/api-sdk';
import PickingTableExport from '../../../components/PickingTableExport';
import { getPickInsightsColumns } from '../../../pickingResultsLib';
import { useStoreTableColumnsProvider } from '../../../../../../hooks/useEntityTableColumnsProvider';
import { getStoreColumnsForPickingPerformance } from '../pickingPerformanceLib';

const PickingPerformanceExport: React.FC = () => {
  const templateOrCalculation = useTemplateOrCalculation();
  const { data, isFetching } = useGetPickingInsightsQuery(templateOrCalculation.id);
  const storeTableColumnsProvider = useStoreTableColumnsProvider();

  const tableColumns = useMemo(() => {
    const storeColumns =
      getStoreColumnsForPickingPerformance<StorePickingInsightsResponse>(storeTableColumnsProvider);
    return getPickInsightsColumns(storeColumns);
  }, [storeTableColumnsProvider]);

  if (!isFetching && data) {
    return (
      <PickingTableExport<StorePickingInsightsResponse>
        dataSource={data}
        columns={tableColumns}
        sheetName="Picking Performance"
        fileNameBase={`PickingPerformance_${templateOrCalculation.id}`}
      />
    );
  }
  return null;
};

export default PickingPerformanceExport;
